
















































































import {Vue, Component, Prop} from "vue-property-decorator";
import {FormField, SelectOption, StackSetup} from "../../../../types";
import EventApi from "../../../api/EventsApi";
import AdminAutomationsEnums from "../../../../enums/admin-automations-types/AdminAutomationsEnums";

@Component({
    components: {},
})

export default class AddAutomationModal extends Vue {
    @Prop({required: true}) private field!: any;

    private automationsTypes: Array<SelectOption> = [
        {
            value: AdminAutomationsEnums.DEAL_TYPE,
            label: AdminAutomationsEnums.DEAL_TYPE_NAME
        },
        {
            value: AdminAutomationsEnums.ENUMERATE_TYPE,
            label: AdminAutomationsEnums.ENUMERATE_TYPE_NAME
        }
    ];

    private type: FormField = {
        id: 'type',
        name: 'type',
        type: '',
        label: 'Type',
        value: this.automationsTypes[0],
        success: true,
        error: null,
        placeholder: 'Type of automation',
        options: this.automationsTypes
    };

    /*private sort: FormField = {
        id: 'sort',
        name: 'sort',
        type: 'number',
        label: 'Sort',
        value: 1,
        success: true,
        error: null,
        placeholder: 'Sorting in list'
    };*/

    private stack: FormField = {
        id: 'stack',
        name: 'stack',
        type: '',
        label: 'Stack',
        value: this.stacksList[0],
        success: true,
        error: null,
        placeholder: 'Stack name',
        options: this.stacksList
    };

    private amount: FormField = {
        id: 'amount',
        name: 'amount',
        type: 'number',
        label: 'Amount of cards',
        value: 1,
        success: true,
        error: null,
        placeholder: 'Amount of cards'
    };

    private target: FormField = {
        id: 'target',
        name: 'target',
        type: '',
        label: 'Target',
        value: AddAutomationModal.targetsList[0],
        success: true,
        error: null,
        placeholder: 'Deal target',
        options: AddAutomationModal.targetsList,
    };

    private get stacksList(): Array<SelectOption>
    {
        return this.field.card_stacks.map((stack: StackSetup) => {
            return {
                value: stack.title,
                label:stack.title
            }
        });
    }

    /**
     * Кому раздаем карты
     */
    public static get targetsList(): Array<SelectOption>
    {
        return [
            {
                value: 'all',
                label: 'all',
            },
            {
                value: 'random',
                label: 'random player',
            },
            {
                value: 'blue',
                label: 'blue',
            },
            {
                value: 'green',
                label: 'green',
            },
            {
                value: 'mint',
                label: 'mint',
            },
            {
                value: 'purple',
                label: 'purple',
            },
            {
                value: 'red',
                label: 'red',
            },
            {
                value: 'yellow',
                label: 'yellow',
            },

        ];
    }

    /**
     * Является автоматизацией по раздаче карт
     * @private
     */
    private get isDealAutomation(): boolean
    {
        return (this.type.value as SelectOption).value === AdminAutomationsEnums.DEAL_TYPE;
    }

    /**
     * Сообщение о добавлении автоматизации для сервера
     * @private
     */
    private get automationMessageData(): {[key: string]: string|number|boolean}
    {
        const dealData = {
            type: (this.type.value as SelectOption).value,
            sort: 1,
            stackTitle: (this.stack.value as SelectOption).value,
            cardsCount: this.amount.value as number,
            target: (this.target.value as SelectOption).value
        };

        switch ((this.type.value as SelectOption).value) {
            case AdminAutomationsEnums.DEAL_TYPE:
                return dealData;

            case AdminAutomationsEnums.ENUMERATE_TYPE:
                return {
                    type: (this.type.value as SelectOption).value,
                    target: (this.target.value as SelectOption).value
                };
            default:
                return dealData;
        }
    }

    private close(): void
    {
        this.$emit('close');
    }

    /**
     * Сохранить, добавить автоматизацию
     * @private
     */
    private save(): void
    {
        EventApi.triggerEvent(EventApi.ADD_AUTOMATION, this.automationMessageData);
        this.close();
    }
}
